export const setDateRange = (state, payload) => {
	state.widgetConfig.dateRange = payload;
}

export const setDateRangeFrom = (state, payload) => {
  state.widgetConfig.dateRange.from = payload;
}

export const setDateRangeTo = (state, payload) => {
  state.widgetConfig.dateRange.to = payload;
}

export const setViewType = (state, payload) => {
  state.widgetConfig.viewType = payload;
}

export const setPeriodType = (state, payload) => {
  state.widgetConfig.periodType = payload;
}

export const setIntervalType = (state, payload) => {
  state.widgetConfig.intervalType = payload;
}

export const setFilters = (state, payload) => {
  state.widgetConfig.filters = payload;
}

export const setTheme = (state, payload) => {
  state.widgetConfig.theme = payload;
}

export const setWidgetConfig = (state, payload) => {
  state.widgetConfig = payload;
}
